export default __webpack_public_path__ + "static/media/icon-menu-calendar.cb77c5f4.svg";